
export const common = {
  // Navigation
  home: 'Home',
  services: 'Services',
  about: 'About',
  gallery: 'Gallery',
  contact: 'Contact',
  reserve: 'Book',
  
  // Buttons
  bookNow: 'Book Now',
  learnMore: 'Learn More',
  whatsapp: 'WhatsApp',
  close: 'Close',
  
  // Hero Section
  heroTitle: 'Travel with',
  heroTitleHighlight: 'Elegance',
  heroDescription: 'Discover Morocco and Canada differently with our premium transport service. Comfort, safety and authentic hospitality.',
  
  // Services
  servicesTitle: 'Our Premium Services',
  servicesDescription: 'A complete range of tourist transport services to meet all your travel needs, from simple transfers to the most exclusive tours.',
  
  // About
  aboutTitle: 'Our Story',
  aboutDescription1: 'For over 10 years, we have been offering an exceptional tourist transport experience in Morocco and Canada. Our passion for Moroccan hospitality and our field expertise allow us to create unforgettable journeys.',
  aboutDescription2: 'Whether you are a business traveler, a family on vacation or a group of friends seeking adventure, we put our know-how at your service so that every kilometer is a pleasure.',
  
  // Values
  security: 'Security',
  securityDesc: 'Well-maintained vehicles and certified drivers for your peace of mind.',
  punctuality: 'Punctuality',
  punctualityDesc: 'Respect for schedules and commitments for reliable service.',
  hospitality: 'Hospitality',
  hospitalityDesc: 'Warm welcome and personalized service in the Moroccan tradition.',
  excellence: 'Excellence',
  excellenceDesc: 'Constant pursuit of perfection in every detail of our services.',
  
  // Testimonials
  testimonialsTitle: 'Customer Testimonials',
  testimonialsDescription: 'Discover what our customers say about their experience with our premium transport service.',
  satisfiedClients: 'Satisfied Clients',
  destinations: 'Destinations',
  customerService: 'Customer Service',
  
  // Reservation
  reservationTitle: 'Book Your Transport',
  reservationDescription: 'Fill out the form below to get a personalized quote or directly book your premium transport service.',
  fullName: 'Full name',
  email: 'Email',
  phone: 'Phone',
  desiredService: 'Desired service',
  selectService: 'Select a service',
  departureDate: 'Departure date',
  departureTime: 'Departure time',
  passengers: 'Passengers',
  passenger: 'passenger',
  departureLocation: 'Departure location',
  destination: 'Destination',
  message: 'Message or special requests',
  messageDescription: 'Describe your specific needs, preferences or questions...',
  sendRequest: 'Send request',
  sending: 'Sending...',
  directContact: 'Direct Contact',
  availability: 'Availability',
  quickResponse: 'Quick Response',
  quickResponseDescription: 'We are committed to responding to you as soon as possible:',
  whatsappResponse: 'WhatsApp: Immediate response',
  emailResponse: 'Email: Within 2 hours',
  freeQuote: 'Free quote with no commitment',
  
  // Contact
  contactTitle: 'Contact Us',
  contactDescription: 'Our team is at your disposal to answer all your questions and assist you in organizing your travels.',
  sendMessage: 'Send us a message',
  subject: 'Subject',
  selectSubject: 'Select a subject',
  quoteRequest: 'Quote request',
  serviceInfo: 'Information about our services',
  complaint: 'Complaint',
  partnership: 'Partnership proposal',
  other: 'Other',
  messageRequired: 'Message',
  messageContactDescription: 'Describe your request in detail...',
  sendMessageBtn: 'Send message',
  ourCoordinates: 'Our Contact Information',
  address: 'Address',
  telephone: 'Phone',
  hours: 'Hours',
  officeHours: 'Office: 8am - 8pm',
  followUs: 'Follow Us',
  ourLocation: 'Our Location',
  
  // Form Messages
  successMessage: 'Your request has been sent successfully! We will contact you quickly.',
  successContactMessage: 'Your message has been sent successfully! We will respond quickly.',
  errorMessage: 'An error occurred. Please try again or contact us directly.',
  charactersLimit: 'characters',
  
  // Footer
  footerDescription: 'Your trusted partner for luxury tourist transport in Morocco and Canada. Discover our destinations with elegance and comfort.',
  ourServices: 'Our Services',
  copyright: '© 2024 HAFY TOURS. All rights reserved.',
  poweredBy: 'Powered by Readdy',
  
  // Common
  yearsExperience: 'Years of experience',
  includedInService: 'Included in service',
  reserveThisService: 'Book this service',
  chatOnWhatsApp: 'Chat on WhatsApp',
  notAvailableYet: 'Not available yet',
  required: '*',
  placeholderName: 'Your full name',
  placeholderEmail: 'your@email.com',
  placeholderPhone: '+1 XXX XXX XXXX',
  placeholderDeparture: 'Airport, hotel, address...',
  placeholderDestination: 'City, tourist site...'
};
